import { render, staticRenderFns } from "./ResourcePlanningReportBudgets.vue?vue&type=template&id=d5e95160&"
import script from "./ResourcePlanningReportBudgets.vue?vue&type=script&lang=js&"
export * from "./ResourcePlanningReportBudgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports